import { Injectable } from '@angular/core';

@Injectable()
export class FeatureDetectionService {
  detect() {
    // detect touch capability
    if (window && document && document.documentElement) {
      const documentHelper = new ElementHelper(document.documentElement);

      let wasTouch = false;
      window.addEventListener('touchstart', () => {
        wasTouch = true;
        documentHelper.addClass('touched');
      });
      window.addEventListener('mousedown', () => {
        if (wasTouch) {
          wasTouch = false;
        } else {
          documentHelper.removeClass('touched');
        }
      });
    }
  }
}

class ElementHelper {
  constructor(private element: HTMLElement) {}

  addClass(className: string) {
    // exclude empty strings
    if (!className || !/\S/.test(className)) {
      return;
    }
    this.element.classList.add(className.trim());
  }

  removeClass(className: string) {
    // exclude empty strings
    if (!className || !/\S/.test(className)) {
      return;
    }
    this.element.classList.remove(className.trim());
  }
}
